import { useWindowWidth } from '@elfsight/lib-utils';
import { useSettings } from '@wu/widget-core';
import { MOBILE_WIDTH } from '../../../../constants';
import { FloatingBar } from './FloatingBar';
import { FloatingMobile } from './FloatingMobile';
import { FloatingProvider, useFloating } from './FloatingProvider';
import { FloatingSmall } from './FloatingSmall';
import { MinimizedPlayer } from './minimized-player';

export function PlayerType() {
  const { position, sourceType } = useSettings();
  const { minimizePlayer } = useFloating();
  const width = useWindowWidth();

  const isCenter = position.toLowerCase().includes('center');

  if (sourceType !== 'rss' && width < MOBILE_WIDTH) {
    return <FloatingMobile />;
  }

  if (minimizePlayer) {
    return <MinimizedPlayer />;
  }

  if (isCenter) {
    return <FloatingBar />;
  }

  return <FloatingSmall />;
}

export function Floating() {
  return (
    <FloatingProvider>
      <PlayerType />
    </FloatingProvider>
  );
}
